/* eslint-disable */
document.addEventListener('DOMContentLoaded', function () {
	function ValidateEmail(input) {
		const validRegex = /^\w+([.-]?\w+)@\w+([-]?\w+)(\.\w{2,3})+$/;
		if (input.match(validRegex)) {
			return true;
		}
	}

	const emailinput = document.getElementById('true-story-email');
	const form = document.getElementById('true-story-form');
	const successMessage = document.getElementById('truestory-success');
	const errorMessage = document.getElementById('truestory-error');
	const errorRecaptcha = document.getElementById('truestory-recaptcha-error');
	if (emailinput) {
		emailinput.addEventListener('keypress', () => {
			errorMessage.style.display = 'none';
			errorRecaptcha.style.display = 'none';
		});
	}

	if (form) {
		form.addEventListener('submit', function (e) {
			e.preventDefault();
			// Get form data			
			const emailInput = document.getElementById('true-story-email');
			const email = emailInput.value;
			const nonceInput = document.getElementById('nonce-true-story');
			const nonce = nonceInput.value;
			const recaptchaToken = document.getElementById('recaptcha_token');
			let recaptchaValue = '';			
			if(recaptchaToken) {
				recaptchaValue = recaptchaToken.value;
			}
			const pdfUrlInput = document.getElementById('pdf_url');
			const pdfUrl = pdfUrlInput.value;
			const titleInput = document.getElementById('true_story_title');
			const title = titleInput.value;
			if (ValidateEmail(email)) {
				// AJAX call
				const xhr = new XMLHttpRequest();
				xhr.open('POST', ajaxload_params.ajaxurl, true); //eslint-disable-line
				xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

				xhr.onreadystatechange = function () {
					if (xhr.readyState === XMLHttpRequest.DONE) {
						if (xhr.status === 200) {
							const response = JSON.parse(xhr.responseText);
							if (response.success === true) {
								successMessage.style.display = 'flex';
								form.style.display = 'none';
								errorRecaptcha.style.display = 'none';
							}else{
								errorRecaptcha.style.display = 'block';
							}
						} else {
							console.error('AJAX request failed.');
						}
					}
				};

				xhr.onerror = function () {
					console.error('AJAX request failed.');
				};

				xhr.send(`action=true_story_form&email=${email}&nonce=${nonce}&recaptcha_token=${recaptchaValue}&pdf_url=${pdfUrl}&title=${title}`);
			} else {
				errorMessage.style.display = 'block';
			}
		});
	}
});

document.addEventListener('DOMContentLoaded', function () {
	grecaptcha.ready(function () { //eslint-disable-line
		grecaptcha //eslint-disable-line
			.execute(ajaxload_params.recaptchaSiteKey, { action: 'true_story_form' })
			.then(function (token) {
				// Attach the token as a hidden field to the form
				var tokenInput = document.createElement('input');
				tokenInput.type = 'hidden';
				tokenInput.id = 'recaptcha_token';
				tokenInput.name = 'recaptcha_token';
				tokenInput.value = token;

				const recaptchaContainer = document.getElementById('recaptcha-container');
				if (recaptchaContainer) {
					recaptchaContainer.innerHTML = ''; // Clear existing content
					recaptchaContainer.appendChild(tokenInput);
				}
 
			});
	});
});
